import { gql } from '@apollo/client'

export const GQL_QUERY_PING_AUTH = gql`
  query {
    pingAuth {
      id
      status
      first_name
      last_name
      settingsJson
      brands {
        id
        name
        slug
        primaryColorHex
        primaryTextColorHex
        logo(style: "orig_") {
          url
        }
      }
      assembler_id # we are use it to get notified if manager can assemble orders
    }
  }
`
